import { render, staticRenderFns } from "./donation-ranking.vue?vue&type=template&id=60b9f9b7&scoped=true&"
import script from "./donation-ranking.vue?vue&type=script&lang=js&"
export * from "./donation-ranking.vue?vue&type=script&lang=js&"
import style0 from "./donation-ranking.vue?vue&type=style&index=0&id=60b9f9b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b9f9b7",
  null
  
)

export default component.exports